import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/cn";
import type { ButtonSharedProps } from "./button-types";
import type { ComponentSize, ComponentTone, ComponentVariant } from "./types";

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  ButtonSharedProps & {
    variant?: ComponentVariant;
    tone?: ComponentTone;
    size?: ComponentSize;
    startIcon?: ReactNode;
    endIcon?: ReactNode;
  };

export function Button({
  className,
  variant = "solid",
  tone = "brand",
  size = "md",
  startIcon,
  endIcon,
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(
        "cf-btn",
        `cf-${size === "md" ? "btn-md" : size === "lg" ? "btn-lg" : "btn-sm"}`,
        `cf-${variant}-${tone}`,
        className
      )}
      {...props}
    >
      {startIcon ? (
        <span
          aria-hidden="true"
          style={{
            display: "inline-flex",
            alignItems: "center",
            // marginRight: children ? "0.45rem" : 0,
          }}
        >
          {startIcon}
        </span>
      ) : null}
      {children}
      {endIcon ? (
        <span
          aria-hidden="true"
          style={{
            display: "inline-flex",
            alignItems: "center",
            marginLeft: children ? "0.45rem" : 0,
          }}
        >
          {endIcon}
        </span>
      ) : null}
    </button>
  );
}
